<template>
  <div class="main">

    <div class="first-page "
         @mousewheel="mousewheel($event)"
         :class=" ver===1?'show':'hide'">
      <webheader></webheader>
      <div class="page-content flex-left flex-column">
        <div style="height:35%"></div>
        <div class="first-title"> 加入神漫</div>
        <div class="flex-top"
             style="padding-top:40px; ">
          <div class="text-gradient">
            <div class="en-title">
              JOIN US
            </div>
          </div>
        </div>
        <div class="company-address flex-top"
             style="padding-top:50px;padding-left:120px">
          <div class="flex-left item-row"><img src="../assets/img/notes.png"
                 alt=""
                 class="pr-16" /> <span class="item-span"> 简历投递 : </span> {{email}}</div>
          <div class="flex-left item-row"><img src="../assets/img/address.png"
                 alt=""
                 class="pr-16" /><span class="item-span"> 神漫基地 : </span> {{addr}}</div>
        </div>
        <div class="company-address flex-top"
             style="padding-left:120px">
          <div class="flex-left item-row"><img src="../assets/img/becareful.png"
                 alt=""
                 class="pr-16" /><span class="item-span"> 注意事项 : </span> 简历（请附带个人作品）</div>
          <div class="flex-left item-row"><img src="../assets/img/invite/03.png"
                 alt=""
                 class="pr-16" /><span class="item-span"> 福利 :</span> S级美食供应 + 节礼 + 年终奖</div>
        </div>
      </div>
    </div>
    <div class="second-page  "
         :class=" ver===2?'show':'hide'">
      <div class=" flex-top  flex-column"
           style="padding-top:36px; height:100%  "
           @mousewheel="mousewheel($event)">
        <div style="width: 1000px;  ">
          <el-input placeholder="输入搜索职位关键字"
                    clearable=""
                    @change="searchChange"
                    v-model="searchKey">
            <template slot="prepend"> <i class="el-icon-search"
                 style="font-size:16px"></i></template>
          </el-input>
        </div>
        <div style="width: 1000px; padding-top:40px; height:calc(100% - 275px) "
             id="">
          <el-scrollbar style="height:100%; ">
            <el-collapse accordion
                         v-model="activeName"
                         style="border:0">
              <el-collapse-item v-for="(item,index) in inviteList"
                                :name='index'
                                style=" background: #282727; border:1px solid #1A1919"
                                :key="index">
                <template slot="title">
                  <div class="invite-name">
                    <span :class="activeName===index?'active':''">{{item.title}}</span>
                    <span class="tag"
                          v-for="(tag,tagindex) in item.joblimits"
                          :key="tagindex">{{tag}}</span>
                  </div>
                </template>
                <div style="color:#DEDEDE">【工作内容】：</div>
                <div style="padding:6px;white-space:pre-wrap">{{item.job_des?item.job_des:'---'}} </div>
                <div style="color:#DEDEDE">【岗位要求】：</div>
                <div style="padding:6px;white-space:pre-wrap">{{item.job_req?item.job_req:'---'}} </div>
                <div style="color:#DEDEDE">【技能要求】：</div>
                <div style="padding:6px;white-space:pre-wrap">{{item.skill_req?item.skill_req:'---'}} </div>
              </el-collapse-item>

            </el-collapse>
          </el-scrollbar>
        </div>
        <tabfooter></tabfooter>
      </div>

    </div>

  </div>
</template>

<script>
import webheader from '@/components/webheader'
import tabfooter from '@/components/tabfooter'
import { selectJob, getconfig } from '@/api/website'
export default {

  components: { tabfooter, webheader },
  name: 'invite',
  data () {
    return {
      activeName: 0,
      ver: 1,
      addr: '',
      email: '',
      searchKey: '',
      inviteList: [
        // { name: '动画制片', tags: ['1-3年经验', '1-3年经验'], requireContent: 'sdfsdfsdf\r\ndsfsdf\r\nsdf\r\nsdf1、具备动画行业相关岗位一年以上相关工作经验；  2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；<br/>2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n\r5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '引擎特效', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验；  2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },

        // { name: '剪辑助理', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },

        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },
        // { name: '资深绑定师', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' },

        // { name: 'Layout', tags: ['1-3年经验', '1-3年经验'], requireContent: '1、具备动画行业相关岗位一年以上相关工作经验； 2、熟悉动画，CG的制作流程，并全程管理和协调策划、制作、运营； 3、具有较强的协调、沟通能力，良好的职业操守，能承受一定的工作压力。 4、优秀的团队意识，有较强的问题判断与解决能力，善于思考和提出建议；\n', workContent: '1、负责动画项目的日常项目管理工作（包括计划、沟通、进度监控、变更等）；\n2、配合项目负责人完成项目中人力协调及制作成本把控；\n3、协调并监督项目实施，保证项目制作顺利完成；\n4、有效控制项目风险，协调解决项目中出现的问题及难点；\n5、负责相关项目各类合同、脚本、报表等文件资料的归档工作；\n', telContent: '' }

      ],
      initList: []
    }
  },
  created () {
    this.initInviteList()
    this.initConfig()
  },

  methods: {
    initConfig () {
      getconfig().then(res => {
        if (res.code === 0) {
          let arr = res.data
          arr.map(item => {
            if (item.name === 'addr') { this.addr = item.value }
            if (item.name === 'email') { this.email = item.value }
          })
          this.initMap()
        }
      })
    },
    initInviteList () {
      let data = {}
      selectJob(data).then(res => {
        if (res.code === 0) {
          this.inviteList = res.data
          this.inviteList.map(item => {
            item.joblimits = item.joblimit_names.split(',')
          })
          this.initList = Object.assign([], this.inviteList)
        }
      })
    },
    searchChange () {
      this.inviteList = this.initList.filter(item => {
        return item.title.toLowerCase().includes(this.searchKey.toLowerCase()) ||
          item.job_des.toLowerCase().includes(this.searchKey.toLowerCase()) ||
          item.skill_req.toLowerCase().includes(this.searchKey.toLowerCase()) ||
          item.job_req.toLowerCase().includes(this.searchKey.toLowerCase())
      })
    },
    mousewheel (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          if (this.ver > 1) {
            this.ver--
          }
        }
        if (e.wheelDelta < 0) {
          if (this.ver < 2) {
            this.ver++
          }
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          if (this.ver > 1) {
            this.ver--
          }
        }
        if (e.detail < 0) {
          if (this.ver < 2) {
            this.ver++
          }
        }
      }
    }
  }
}
</script>

<style  scoped>
.item-span{
  display: block;
  width: 100px;
  text-align: left;
}
.item-row {
  width: 400px;
  height: 50px;
  line-height: 50px;
}
.active {
  color: #00ffee;
}
.invite-name {
  padding-left: 36px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #dedede;
}
.tag {
  margin-left: 12px;
  padding: 2px 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(139, 139, 139, 1);
  background: rgba(55, 54, 54, 1);
  opacity: 1;
  border-radius: 2px;
}
.company-address {
  width: 100%;
  text-align: center;
  height: 50px;

  line-height: 50px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.show {
  animation: 1s fadeInUp;
  display: block;
}
.hide {
  animation: 1s backOutUp;
  display: none;
}
.desc-text {
  padding-left: 16px;
}
.left-content {
  text-align: right;
  padding: 110px;
  height: 60%;
}
.right-content {
  height: 100%;
  width: 50%;
  padding: 110px 0;
  position: relative;
}
.page-content {
  height: 100%;
}
.second-page {
  width: 100%;
  height: 100%;
  background: url("../assets/img/invite/02.png");
}
.first-page {
  height: calc(100%);
  background: url("../assets/img/invite/01.png");
}
</style>



// WEBPACK FOOTER //
// src/view/invite.vue